import type { EntryPoint, EntryPointComponent } from 'react-relay';
/* eslint-disable eslint-comments/no-restricted-disable */
/* eslint-disable @atlassian/react-entrypoint/no-imports-in-entrypoint-file */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import HubHomeContentWrapperQueryParameters, {
	type hubHomeContentWrapperQuery,
} from '@atlassian/hub-home/HubHomeContentWrapperQueryParameters';

type HelpCenterSettingsSupportWebsiteEditAppEntryPointComponent = EntryPointComponent<
	{
		customEditQuery: hubHomeContentWrapperQuery;
	},
	{},
	{},
	{} | null
>;

export const HelpCenterSettingsSupportWebsiteEditAppEntryPoint: EntryPoint<
	HelpCenterSettingsSupportWebsiteEditAppEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<HelpCenterSettingsSupportWebsiteEditAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-setting-support-website-edit-app" */ './HelpCenterSettingsSupportWebsiteEditComponent.tsx',
	),
	getPreloadProps: ({
		context: {
			match: {
				params: { helpCenterId, pageId },
			},
		},
		tenantContext: { cloudId, activationId },
	}: EntryPointRouteParams) => {
		return {
			queries: {
				customEditQuery: {
					parameters: HubHomeContentWrapperQueryParameters,
					variables: {
						cloudId,
						hubAri: `ari:cloud:help::help-center/${activationId}/${helpCenterId}`,
						isDraft: false,
						pageAri: `ari:cloud:help::page/${activationId}/${pageId || helpCenterId || ''}`,
						hubEditMode: true,
					},
					options: {
						fetchPolicy: 'store-or-network' as const,
					},
				},
			},
		};
	},
});
